<script>
import { Line } from "vue-chartjs";
import "./style.css";

export default {
  extends: Line,
  props: {
    data: Object,
    nueroFeedbackHover: Function,
    onGraphClick: Function,
  },
  data() {
    const emotions = {
      joy: this.data.emotions.map((p) => {
        return {
          value: p.joy,
          timestamp: p.timestamp,
        };
      }),
      attention: this.data.emotions.map((p) => {
        return {
          value: p.attention,
          timestamp: p.timestamp,
        };
      }),
      frustration: this.data.emotions.map((p) => {
        return {
          value: p.frustration,
          timestamp: p.timestamp,
        };
      }),
    };
    const colours = {
      joy: "#00deab",
      attention: "#ffaa00",
      frustration: "#FF00A9",
    };

    const autoPoints = (this.data.significant_points || []).filter(
      (p) => p.emotion !== "manual"
    );

    const vueComponent = this;

    const clickHandler = function (event) {
      const percent = event.offsetX / event.srcElement.scrollWidth;
      vueComponent.onGraphClick(percent);
      const element = this.getElementAtEvent(event)[0];
      if (element && element._datasetIndex === 0 && autoPoints[element._index]) {
        vueComponent.$emit("emotionPointClicked", autoPoints[element._index].id);
      }
    };

    return {
      chartdata: {
        labels: this.data.emotions.map((p) => p.timestamp),
        datasets: [
          {
            label: "significant points",
            borderColor: "#ebebef",
            pointBackgroundColor: autoPoints.map((p) => {
              return colours[p.emotion];
            }),
            data: autoPoints.map((p) => {
              const emotionPoint = emotions[p.emotion] ? emotions[p.emotion].find(
                (i) => p.timestamp_top === i.timestamp
              ) : null;
              return {
                x: p.timestamp_top,
                y: emotionPoint ? emotionPoint.value : 0,
              };
            }),
            fill: false,
            showLine: false,
            pointRadius: 9,
            pointBorderWidth: 3,
            pointHoverRadius: 5,
            pointHoverBorderColor: "#000",
            pointHoverBorderWidth: 3,
          },
          {
            label: "Attention",
            backgroundColor: "#ffaa00",
            borderColor: "#ffaa00",
            data: emotions.attention.map((p) => Number(p.value || 0)),
            fill: false,
            pointRadius: 0,
            borderWidth: 2,
            spanGaps: true,
          },
          {
            label: "Joy",
            backgroundColor: "#00deab",
            borderColor: "#00deab",
            data: emotions.joy.map((p) => Number(p.value || 0)),
            fill: false,
            pointRadius: 0,
            borderWidth: 2,
            spanGaps: true,
          },
          {
            label: "frustration",
            backgroundColor: "#FF00A9",
            borderColor: "#FF00A9",
            data: emotions.frustration.map((p) => Number(p.value || 0)),
            fill: false,
            pointRadius: 0,
            borderWidth: 2,
            spanGaps: true,
          },
        ],
      },
      options: {
        onClick: clickHandler,
        tooltips: {
          enabled: false,
        },
        layout: {
          padding: {
            top: 20,
            bottom: 20,
          },
        },
        scales: {
          yAxes: [
            {
              display: false,
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              display: false,
              gridLines: {
                display: true,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        hover: { mode: null },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
